<template>
    <CButton
        :block="block"
        :color="color"
        :disabled="loading"
        :type="type"
        @click="$emit('click')"
    >
        <slot name="loader" v-bind:loader="loading">
            <CSpinner
                class="mr-1"
                color="light"
                size="sm"
                v-if="loading"
            />
        </slot>
        <slot>
        </slot>
    </CButton>
</template>

<script>

export default {
    name: "ButtonLoading",

    props: {
        block: {
            type: Boolean,
            default: false
        },
        color: String,
        loading: Boolean,
        type: String
    }

}
</script>
<style lang="scss">

</style>